import { Component } from "@/types"
import { logger } from "@/utils/logger"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useEffect } from "react"

export const presets = {}

export interface Props extends Component {}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60 * 60 * 1000 } },
})

export function ReactQueryProvider({ children }: Props) {
  useEffect(() => {
    logger.debug("[Initialization] React Query")
    return () => logger.debug("[Disposal] React Query")
  }, [])
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
